var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperetureReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0H5C1.5 0 0 2 0 5V15C0 18 1.5 20 5 20H13C16.5 20 18 18 18 15V5C18 2 16.5 0 13 0ZM5 10.25H9C9.41 10.25 9.75 10.59 9.75 11C9.75 11.41 9.41 11.75 9 11.75H5C4.59 11.75 4.25 11.41 4.25 11C4.25 10.59 4.59 10.25 5 10.25ZM13 15.75H5C4.59 15.75 4.25 15.41 4.25 15C4.25 14.59 4.59 14.25 5 14.25H13C13.41 14.25 13.75 14.59 13.75 15C13.75 15.41 13.41 15.75 13 15.75ZM15.5 7.25H13.5C11.98 7.25 10.75 6.02 10.75 4.5V2.5C10.75 2.09 11.09 1.75 11.5 1.75C11.91 1.75 12.25 2.09 12.25 2.5V4.5C12.25 5.19 12.81 5.75 13.5 5.75H15.5C15.91 5.75 16.25 6.09 16.25 6.5C16.25 6.91 15.91 7.25 15.5 7.25Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperetureReport);
export default __webpack_public_path__ + "static/media/tempereture_report.d869c4653b71abecaa2069cc8de7a0c4.svg";
export { ForwardRef as ReactComponent };